module.exports = __webpack_public_path__ + "static/NightInTheWoods9-b75ef9c8888b33d94c2e65ccb7c06d03.webp";